import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconButton, IconButtonTheme, IconButtonSize } from '@apply/components';

export enum FlyoutDirection {
    Left = 'flyleft',
    Right = 'flyright',
    Down = 'flydown',
}

export const FlyoutMenuButton: React.FC<{
    id: string;
    theme: IconButtonTheme;
    size: IconButtonSize;
    disabled?: boolean;
    icon: IconDefinition;
    handleClick?: React.MouseEventHandler;
    hint?: string;
    bubbleNumber?: number;
    children: any;
    direction: FlyoutDirection;
}> = ({ id, theme, handleClick, size, icon, hint, bubbleNumber, disabled, children, direction }) => {
    return (
        <>
            <details className={`flyout ${size}`}>
                <summary role='button'>
                    <IconButton
                        id={id}
                        theme={theme}
                        size={size}
                        disabled={disabled}
                        icon={icon}
                        hint={hint}
                        bubbleNumber={bubbleNumber}
                    ></IconButton>
                </summary>
                <div className={`flyout container ${size} ${theme} ${direction}`}>{children}</div>
            </details>
        </>
    );
};
